module.exports = __webpack_public_path__ + "img/cbam-4-en.bb306916.png";